import { render, staticRenderFns } from "./NotificationToaster.vue?vue&type=template&id=4423de58&scoped=true"
import script from "./NotificationToaster.vue?vue&type=script&lang=js"
export * from "./NotificationToaster.vue?vue&type=script&lang=js"
import style0 from "./NotificationToaster.vue?vue&type=style&index=0&id=4423de58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423de58",
  null
  
)

export default component.exports